import { useEffect } from "react";
import '../styles/notFound.css';

export default function Home2() {
    useEffect(() => {
        document.body.classList.add("no-header-footer");
        return () => document.body.classList.remove("no-header-footer");
    }, []);

  return (
    <main>
        <div id="notfound">
            <div class="notfound">
                <div class="notfound-404">
                    <h1>404</h1>
                    <h2>Page not found</h2>
                </div>
                <a href="/">
                    Início
                </a>
            </div>
        </div>
    </main>
  );
}